import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { AccountingAccountsService } from '../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountingAccountsModel } from '../../accounting/accounting-accounts/accounting-accounts.model';
import { InvestmentFinancialModel } from './investment-financial.model';
import { InvestmentFinancialService } from './investment-financial.service';

@Component({
    selector: 'convfact-investment-financial',
    templateUrl: './investment-financial.component.html',
    styleUrls: ['./investment-financial.component.css'],
    standalone: false
})

export class InvestmentFinancialComponent implements OnInit {

  public investmentFinancial = new InvestmentFinancialModel;
  public accounts: AccountingAccountsModel[] = [];

  public spinner: boolean = false;
  public ready: boolean = false;

  constructor(
    private investmentFinancialService: InvestmentFinancialService,
    private accountingAccountsService: AccountingAccountsService,
    public snackBar: MatSnackBar,
    private router: Router
  ) { }

  public ngOnInit(): void {
    this.accountingAccountsService.getListInvestmentsFinancialAccounts()
      .then(data => this.accounts = data);

    const temp = this.router.url.split('/');
    this.spinner = true;
    if (temp.length == 5) {
      const uid = temp[4];
      this.investmentFinancialService.get(uid)
        .then(response => {
          this.investmentFinancial = response;
          this.spinner = false;
          this.ready = true;
        })
    }
    else {
      this.spinner = false;
      this.ready = true;
    }
  }

  public saveData(investmentFinancial: InvestmentFinancialModel): void {
    this.spinner = true;

    if (investmentFinancial.uid == null) {
      this.investmentFinancialService.add(investmentFinancial)
        .then(response => {
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError(error.error['message']);
        })
    } else {
      this.investmentFinancialService.edit(investmentFinancial)
        .then(response => {
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError("Ha ocurrido un error inesperado al actualizar la inversion")
        })
    }
  }

  public displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(error, '', options);
  }

  public returnToIndex(): void {
    this.router.navigate(['investment/financial']);
  }
}
